export const assetPath = (path) => {
    if (!path) {
        return path;
    }

    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${process.env.PUBLIC_URL || ""}${normalizedPath}`;
};

export const assetBackgroundImage = (path) => `url('${assetPath(path)}')`;
